import { Text2, skinVars } from '@telefonica/mistica';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getListMotivesById } from '../../services/ProblemService';
import ChatSupport from '../ChatSupport';
import ChatText from '../ChatText';
import './index.scss';
import {
    IProblemDiagnosis,
    EProblemFeedback,
    EProblemFeedbackType,
    IProblemMotive,
    IProblemCategory,
} from '../../models/Problems.interfaces';
import navigateParams from '../../utils/navigation/navigateParams';
import { useNavigate } from 'react-router-dom';
import { literalsFeedback, LoaderMessage } from '../../pages/support/utils.chat';
import { IChatComponent } from '../../pages/support/solveIncident';

export interface IChatNumberProduct {
    product: IChatComponent;
    treeMotives: boolean | IProblemMotive[];
    onEmitMotive: ({ product, step }: { product: IProblemDiagnosis; step: number }) => void;
}

export const ChatMotivesProblem: React.FC<IChatNumberProduct> = ({
    product,
    treeMotives = false,
    onEmitMotive,
}: IChatNumberProduct) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectMotives, setSelectMotives] = useState(true);
    const [selectedMotives, setSelectedMotives] = useState<string>('');
    const [motives, setMotives] = useState<any>([]);
    const [lottieLoading, setLottieLoading] = useState<any>(true);
    const selectTabMotive = (problem: IProblemCategory, index: number) => {
        const { id, products, type } = product.product;
        const { motive } = problem;
        const _product: IProblemDiagnosis = {
            id,
            products,
            type,
            motive: {
                id: 'motive' in motives[index] ? problem?.motive?.id : problem.id,
                description: problem?.description,
                treeMotives: 'motive' in motives[index],
            },
        };
        setSelectMotives(false);
        setSelectedMotives('motive' in motives[index] ? motive?.description : problem?.name);
        onEmitMotive({ product: _product, step: 4 });
    };

    const selectedMotiveProblem = () => {
        if (selectMotives === false) return <ChatText context={'response'} text={`${selectedMotives}`}></ChatText>;
    };

    useEffect(() => {
        if (!treeMotives) {
            getListMotivesById({ categoryId: product.product.id })
                .then((response: any) => {
                    const { data } = response;
                    setMotives(data);
                    setLottieLoading(false);
                    window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setLottieLoading(false);
                    const queryParams = {
                        phase: EProblemFeedbackType.ERROR,
                        error: EProblemFeedback.DIAGNOSIS,
                        ...literalsFeedback(EProblemFeedback.DIAGNOSIS),
                    };
                    if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                        navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                    }
                });
        } else {
            setMotives(treeMotives);
            setLottieLoading(false);
        }
    }, []);

    return (
        <div className='chatMotivesProblem'>
            {lottieLoading ? (
                LoaderMessage
            ) : (
                <div>
                    <ChatSupport text={t('supportChatMotiveProblemAnswer')}></ChatSupport>
                    {selectMotives &&
                        motives?.map((item: IProblemCategory, index: number) => {
                            return (
                                <div
                                    key={item.id}
                                    onClick={() => selectTabMotive(item, index)}
                                    className='chatMotivesProblem__motive'
                                    style={{
                                        borderStyle: 'solid',
                                        borderWidth: '1px',
                                        borderColor: skinVars.colors.controlActivated,
                                    }}
                                >
                                    <Text2 regular color={skinVars.colors.textLink}>
                                        {item.description}
                                    </Text2>
                                </div>
                            );
                        })}
                </div>
            )}
            {selectedMotiveProblem()}
        </div>
    );
};

export default ChatMotivesProblem;
